import { makeStyles } from '@material-ui/core/styles';
import mixins from '../../../assets/styles/mixins.scss';

const useTimeStyles = makeStyles({
  timeWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  },
  label: {
    fontSize: 14,
    fontWeight: mixins.fontWeight400,
    color: mixins.greyScaleColor,
    fontFamily: mixins.fontFamilyPlusSans,
    lineHeight: '22px'
  },
  timeFieldWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    width: 144,
    height: 48,
    border: `1px solid ${mixins.amethyst}`,
    boxSizing: 'border-box',
    borderRadius: 4
  },
  segmentedInput: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '75%',
    height: '100%',
    padding: 0,
    boxSizing: 'border-box',
    gap: 0
  },
  timeSegment: {
    border: 'none',
    background: 'transparent',
    outline: 'none',
    padding: 0,
    fontSize: mixins.fontSize16,
    fontFamily: mixins.fontFamilyPlusSans,
    textAlign: 'center',
    width: 28,
    cursor: 'text',
    color: mixins.greyScaleColor
  },
  separator: {
    fontSize: mixins.fontSize16,
    color: mixins.greyScaleColor,
    fontFamily: mixins.fontFamilyPlusSans
  },
  periodButton: {
    border: 'none',
    background: 'transparent',
    outline: 'none',
    fontSize: mixins.fontSize16,
    fontFamily: mixins.fontFamilyPlusSans,
    padding: '0px !important',
    cursor: 'text',
    color: mixins.timeIconColor,
    borderRadius: 2,
    minWidth: 28,
    textAlign: 'center'
  },
  clockIcon: {
    position: 'absolute',
    right: 12,
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    '& svg': {
      color: mixins.timeIconColor
    }
  }
});

export default useTimeStyles;
